import { MultiTariffUpsaleModel } from 'reactApp/sections/QuotaLanding/multiTariffUpsaleDialog/models/MultiTariffUpsaleDialog.model';
import type { MultiTariffUpsaleRadioType } from 'reactApp/sections/QuotaLanding/multiTariffUpsaleDialog/models/MultiTariffUpsaleDialog.model.types';

export class FamilyMultiTariffUpsaleModel extends MultiTariffUpsaleModel {
    override getTitleDescription() {
        return 'Если подключите Основной тариф + функции для семьи сразу на год — сможете сэкономить';
    }

    override getDwh(selected: MultiTariffUpsaleRadioType) {
        const dwh = super.getDwh(selected);
        return { ...dwh, action: 'modal-upsale-family' };
    }
}
